import { render, staticRenderFns } from "./rankmatchseasonadd.vue?vue&type=template&id=6af56662&scoped=true"
import script from "./rankmatchseasonadd.vue?vue&type=script&lang=js"
export * from "./rankmatchseasonadd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af56662",
  null
  
)

export default component.exports